import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { formatDate, formatBattleName, isLive } from '../utils';

export default function Battles() {
  const [battles, setBattles] = useState(null);
  const [filter, setFilter]   = useState('');
  const [sort, setSort]       = useState('newest');
  const [error, setError]     = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.battles().then(setBattles).catch(e => setError(e.message));
  }, []);

  if (error)    return <div className="page"><div className="error-box">{error}</div></div>;
  if (!battles) return <div className="page-center"><div className="spinner" /></div>;

  const q = filter.toLowerCase();
  let list = battles.filter(b =>
    !q || formatBattleName(b.clanBattleName).toLowerCase().includes(q) || b.clanBattleName.toLowerCase().includes(q)
  );

  if (sort === 'oldest') list = [...list].reverse();
  else if (sort === 'live-first') {
    list = [...list].sort((a, b) => {
      const al = isLive(a) ? 1 : 0, bl = isLive(b) ? 1 : 0;
      return bl - al || new Date(b.createdAt) - new Date(a.createdAt);
    });
  }

  return (
    <div className="page fade-in">
      <div className="page-header">
        <div>
          <div className="page-header-title">Battles</div>
          <div className="page-header-sub">{battles.length} battles total</div>
        </div>
      </div>

      <div className="filter-bar">
        <input
          className="filter-input"
          placeholder="Filter by name…"
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <select value={sort} onChange={e => setSort(e.target.value)}>
          <option value="newest">Newest first</option>
          <option value="oldest">Oldest first</option>
          <option value="live-first">Live first</option>
        </select>
      </div>

      {list.length === 0 && <div className="empty-msg">No battles match your filter.</div>}

      <div className="battle-grid">
        {list.map(b => {
          const live = isLive(b);
          const name = formatBattleName(b.clanBattleName);
          return (
            <div
              key={b.id}
              className="battle-card"
              onClick={() => navigate(`/battle/${b.id}`)}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                <div className="battle-card-name">{name}</div>
                {live
                  ? <span className="badge badge-live">Live</span>
                  : <span className="badge badge-done">Done</span>}
              </div>
              <div className="battle-card-meta">
                <div className="battle-card-meta-row">
                  <span>Started</span>
                  <span>{formatDate(b.createdAt)}</span>
                </div>
                <div className="battle-card-meta-row">
                  <span>Ended</span>
                  <span>{formatDate(new Date(Number(b.finishesAt) * 1000))}</span>
                </div>
              </div>
              <div style={{ color: 'var(--blue)', fontSize: '.82rem', fontWeight: 600 }}>
                View standings →
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
